import React, { useState } from "react";
import {
  Drawer,
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  IconButton,
  Divider
} from "@mui/material";
import {
  getLocalValue,
  IsSmallScreen,
  LoacalVariables
} from "../../commonFunctions/CommonFunctions";
import { getMenu } from "./menu";
import { Link, useLocation } from "react-router-dom";
import logo from "../../images/willsoar.svg";
import logo2 from "../../images/simplestimate-logo.svg";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";

interface SidebarProps {
  open: boolean;
  handleDrawerToggle: () => void;
  handleCollapse: () => void;
  collapse: boolean;
  drawerWidth?: number;

  primaryColor: string;
  secondaryColor: string;
  hoverColor: string;
  textColor: string;
  iconColor: string;
  hoverTextColor: string;
  backgroundColor: string;
  selectedBackgroundColor: string;
  boxShadowColor: string;
}

const Sidebar2: React.FC<SidebarProps> = ({
  open,
  handleDrawerToggle,
  collapse,
  drawerWidth = 218,

  textColor,
  hoverColor,
  hoverTextColor,
  handleCollapse,
  boxShadowColor,
  iconColor
}) => {
  const isMobile = IsSmallScreen();
  const location = useLocation(); // Get the current location from React Router

  const [hoveredMenuPosition, setHoveredMenuPosition] = useState({ top: 0 });

  const userType: any = getLocalValue(LoacalVariables.UserType);
  const [openChildMenus, setOpenChildMenus] = useState<Record<number, boolean>>(
    {}
  );

  const [hoveredMenuId, setHoveredMenuId] = useState<number | null>(null);

  // Helper function to determine if the menu item is selected
  const isSelected = (path?: string) => {
    return path && location.pathname === path;
  };

  const menu = getMenu(userType);

  const handleToggleChildMenu = (id: number) => {
    setOpenChildMenus((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const handleMouseEnter = (id: number) => {
    setHoveredMenuId(id);

    // Find the hovered list item position
    const listItem = document.getElementById(`menu-item-${id}`);
    if (listItem) {
      const rect = listItem.getBoundingClientRect();
      setHoveredMenuPosition({ top: rect.top + window.scrollY });
    }
  };

  const handleMouseLeave = () => {
    setHoveredMenuId(null);
  };

  return (
    <Drawer
      variant={isMobile ? "temporary" : "persistent"}
      anchor="left"
      open={open}
      onClose={handleDrawerToggle}
      sx={{
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: collapse ? 65 : drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "#0b1a36",
          color: "#fff",
          overflowX: "hidden",
          transition: "all .4s ease",
          boxShadow: "inset -15px 0 50px 1px #000",
          zIndex: 1002
        }
      }}
    >
      {/* Logo */}
      <Box sx={{ p: collapse ? 1 : 2, textAlign: "center" }}>
        <img
          src={collapse ? logo2 : logo}
          alt="logo"
          width={collapse ? 45 : 140}
          height={collapse ? 45 : 24}
        />
      </Box>

      {/* Menu Items */}
      <List>
        {menu.staticMenu.map((item: any) => (
          <React.Fragment key={item.id}>
            <li
              onMouseEnter={() => handleMouseEnter(item.id)}
              onMouseLeave={handleMouseLeave}
              style={{ padding: 4 }}
            >
              <ListItemButton
                component={Link}
                to={item.path || "#"}
                onClick={() => item.children && handleToggleChildMenu(item.id)}
                sx={{
                  minHeight: 48,
                  justifyContent: collapse ? "center" : "initial",
                  px: collapse ? 1.5 : 2.5,
                  borderRadius: 1.5,
                  // backgroundColor: isSelected(item.path)
                  //   ? hoverColor
                  //   : "transparent",
                  color: isSelected(item.path) ? hoverTextColor : textColor,
                  "&:hover": {
                    // backgroundColor: hoverColor,
                    color: hoverTextColor
                  }
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: collapse ? 0 : 2,
                    justifyContent: "center",
                    color: "inherit"
                  }}
                >
                  <item.icon />
                </ListItemIcon>
                {!collapse && (
                  <ListItemText
                    primary={item.label}
                    sx={{
                      "& .MuiTypography-root": {
                        fontSize: "14px"
                      }
                    }}
                  />
                )}
                {!collapse && item.children && (
                  <ListItemIcon>
                    {openChildMenus[item.id] ? (
                      <ExpandMore sx={{ color: textColor }} />
                    ) : (
                      <ExpandLess sx={{ color: textColor }} />
                    )}
                  </ListItemIcon>
                )}
              </ListItemButton>
            </li>

            {/* Hover Menu when collapsed */}
            {item.children && collapse && hoveredMenuId === item.id && (
              <ul
                className="child-menu"
                style={{
                  position: "fixed",
                  left: 80,
                  top: hoveredMenuPosition.top,
                  zIndex: 1500,
                  backgroundColor: "#fff",
                  padding: "0",
                  margin: "0",
                  listStyle: "none",
                  borderRadius: 10,
                  boxShadow: `0 10px 30px ${boxShadowColor}`
                }}
                onMouseEnter={() => setHoveredMenuId(item.id)}
                onMouseLeave={() => setHoveredMenuId(null)}
              >
                {item.children.map((child: any) => (
                  <li
                    key={child.id}
                    style={{ width: "14rem", borderRadius: 10 }}
                  >
                    <ListItemButton
                      component={Link}
                      to={child.path || "#"}
                      sx={{
                        padding: "8px",
                        height: 50,
                        color: textColor,
                        "&:hover": {
                          color: hoverTextColor
                          // backgroundColor: hoverColor
                        }
                      }}
                    >
                      <ListItemText
                        primary={child.label}
                        sx={{
                          padding: "8px",
                          "& .MuiTypography-root": { fontSize: "14px" }
                        }}
                      />
                    </ListItemButton>
                  </li>
                ))}
              </ul>
            )}

            {/* Expand Child Menu when not collapsed */}
            {item.children && openChildMenus[item.id] && !collapse && (
              <ul style={{ listStyle: "none", marginRight: "7px" }}>
                {item.children.map((child: any) => (
                  <li key={child.id}>
                    <ListItemButton
                      component={Link}
                      to={child.path || "#"}
                      sx={{
                        // backgroundColor: isSelected(child.path)
                        //   ? hoverColor
                        //   : "transparent",
                        color: isSelected(child.path)
                          ? hoverTextColor
                          : textColor,
                        mt: 0.5,
                        justifyContent: "initial",
                        borderRadius: 1.5,
                        "&:hover": {
                          // backgroundColor: hoverColor,
                          color: hoverTextColor
                        }
                      }}
                    >
                      <ListItemText
                        primary={child.label}
                        sx={{
                          "& .MuiTypography-root": { fontSize: "14px" }
                        }}
                      />
                    </ListItemButton>
                  </li>
                ))}
              </ul>
            )}
          </React.Fragment>
        ))}
      </List>

      <Box sx={{ position: "absolute", bottom: 0, width: "100%" }}>
        {/* Divider + Collapse Button */}
        <Divider sx={{ backgroundColor: "white" }} />

        <Box
          sx={{ display: "flex", justifyContent: "flex-end", px: 1, py: 0.5 }}
        >
          <IconButton
            onClick={handleCollapse}
            sx={{
              color: "#fff"
            }}
          >
            {collapse ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
          </IconButton>
        </Box>
      </Box>
    </Drawer>
  );
};

export default Sidebar2;
